import { render, staticRenderFns } from "./QuizIntro.vue?vue&type=template&id=bce1c2be&scoped=true"
import script from "./QuizIntro.vue?vue&type=script&lang=js"
export * from "./QuizIntro.vue?vue&type=script&lang=js"
import style0 from "./QuizIntro.vue?vue&type=style&index=0&id=bce1c2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce1c2be",
  null
  
)

export default component.exports